import { apiClient } from './apiClient';
import type { CollaboratorProfile } from './collaboratorProfileApi';

export type MyTeamMember = {
  userId: string;
  name: string;
  email: string;
  jobTitle?: string | null;
  teamNames: string[];
  managerNames: string[];
  isCurrentUser: boolean;
  isImmediateManager: boolean;
  isSubordinate: boolean;
  isTeamLeader: boolean;
};

export type MyTeamHierarchyNode = {
  userId: string;
  name: string;
  email: string;
  jobTitle?: string | null;
  isCurrentUser: boolean;
  isImmediateManager: boolean;
  isSubordinate: boolean;
  children: MyTeamHierarchyNode[];
};

export type MyTeamOverview = {
  currentUserId: string;
  currentUserName: string;
  isManager: boolean;
  members: MyTeamMember[];
  hierarchy: MyTeamHierarchyNode[];
};

export async function getMyTeamOverview(): Promise<MyTeamOverview> {
  const response = await apiClient.get<MyTeamOverview>('/v1/people/my-team');
  return response.data;
}

export async function getMyTeamMemberProfile(userId: string): Promise<CollaboratorProfile> {
  const response = await apiClient.get<CollaboratorProfile>(
    `/v1/people/my-team/members/${userId}/profile`,
  );
  return response.data;
}
